// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3xrq3","productName":"Table_productName__3PYQv"};